import { BOGeneralValues } from "./BOGeneralValues.model";

export class BOAdvancedDirectiveDocument extends BOGeneralValues{
    id:number;
    advancedDirectiveDocumentAnswer:string;
    advancedDirectiveDocumentDate?:Date | undefined;
    epsId?:number | undefined;
}